import { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { api } from '../api.js'
import { useAuth } from '../auth/AuthContext.jsx'

// Teacher: one course's participants — who paid the course OR who joined.

export function TeacherCourseDetailPage() {
  const { t } = useTranslation()
  const { id } = useParams()
  const { user, loading: authLoading } = useAuth()
  const [course, setCourse] = useState(null)
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const allowed = user && (user.role === 'teacher' || user.role === 'admin')

  useEffect(() => {
    if (authLoading || !allowed) return
    api.teacher.participants(id)
      .then((d) => { setCourse(d.course); setRows(d.participants || []) })
      .catch((e) => setError(e.code || 'server'))
      .finally(() => setLoading(false))
  }, [authLoading, allowed, id])

  if (authLoading || loading) return <main className="container"><p>{t('common.loading')}</p></main>
  if (!allowed) {
    return <main className="container"><p className="error">{t('teacher.errors.not_teacher')}</p></main>
  }
  if (error || !course) {
    return (
      <main className="container">
        <p className="error">{t(`teacher.errors.${error || 'not_found'}`, { defaultValue: error })}</p>
        <p><Link to="/teacher">← {t('teacher.title')}</Link></p>
      </main>
    )
  }

  return (
    <main className="container">
      <p><Link to="/teacher">← {t('teacher.title')}</Link></p>
      <h1>{course.name}</h1>
      <p className="muted">
        {t(`admin_courses.type_${course.type}`, { defaultValue: course.type })}
        {(course.date_start || course.date_end)
          ? ` · ${course.date_start || '…'} → ${course.date_end || '…'}`
          : ''}
      </p>
      <p style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
        {(course.type === 'hourly' || course.type === 'sessions') && course.managed !== 'self' && (
          <Link to={`/teacher/courses/${course.id}/attendance`}><button type="button">{t('teacher.attendance')}</button></Link>
        )}
        {/* Admins can edit the roster for ANY bbso-managed course. */}
        {user.role === 'admin' && course.managed === 'bbso' && (
          <Link to={`/admin/courses/${course.id}/participants`}><button type="button">{t('teacher.manage_participants')}</button></Link>
        )}
      </p>

      <h2>{t('teacher.participants_title', { count: rows.length })}</h2>
      {rows.length === 0 && <p className="muted">{t('teacher.no_participants')}</p>}

      {rows.length > 0 && (
        <table className="results-table">
          <thead>
            <tr>
              <th>{t('teacher.col_participant')}</th>
              <th>{t('teacher.col_account')}</th>
              <th>{t('teacher.col_status')}</th>
              <th>{t('teacher.col_paid')}</th>
              <th>{t('teacher.col_enrolled_at')}</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id}>
                <td>{r.participant_name}</td>
                <td>{r.account_name}<br /><span className="muted small">{r.account_email}</span></td>
                <td>{t(`enrollments.status_${r.status}`, { defaultValue: r.status })}</td>
                <td>{Number(r.paid) === 1 ? t('teacher.paid_yes') : t('teacher.paid_no')}</td>
                <td className="small">{r.enrolled_at}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </main>
  )
}
